import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import { Core } from '../core/Core';
import { TweenService } from '../core/TweenService';

export class Mat {
	core: Core;
	geometry: THREE.CylinderGeometry;
	material: THREE.Material;
	mesh: THREE.Mesh;
	dramaticEntrance: boolean;
	yPosition: number = -0.015;

	/**
	 * Constructor
	 * A Mat.  Nice underfoot.
	 * */
	constructor(core: Core, dramaticEntrance: boolean = false) {
		this.core = core;
		this.dramaticEntrance = dramaticEntrance;

		const { geometry, material, mesh } = this.createMat();
		this.geometry = geometry;
		this.material = material;
		this.mesh = mesh;

		if (this.dramaticEntrance) this.animateDramaticEntrance();
	}

	/**
	 * Create the Mat
	 */
	createMat() {
		const geometry = new THREE.CylinderGeometry(0.7, 0.7, 0.01, 30);
		const material = new THREE.MeshBasicMaterial({ color: "#ffffff", opacity: 1, transparent: true });
		const mesh = new THREE.Mesh(geometry, material);
		mesh.position.set(0, this.yPosition, 0);
		mesh.rotation.set(0, Math.PI * 2, Math.PI);
		mesh.scale.set(1, 1, 0.75);

		this.core.scene.add(mesh);

		return { geometry, material, mesh };
	}

	/**
	 * Creates an interesting entrance
	 * @param opacity Sets the opacity of the mat
	 */
	animateDramaticEntrance(opacity: number = 1) {
		this.material.opacity = 0;
		this.mesh.position.y = -0.1;

		const sTween: TweenService = this.core.s('Tween');
		sTween.createTween({
			name: 'matFade',
			targetObject: this.material,
			modifiedPropertyObject: { opacity: opacity },
			durationMS: 1250,
			easing: TWEEN.Easing.Cubic.Out,
			delayMS: 2000
		});

		sTween.createTween({
			name: 'matPos',
			targetObject: this.mesh.position,
			modifiedPropertyObject: { y: this.yPosition },
			durationMS: 1500,
			easing: TWEEN.Easing.Cubic.Out,
			delayMS: 2000
		});
	}
}
